import type { FieldConfig, StepStatus } from './VerticalStepForm.model';
import type { FieldErrors } from 'react-hook-form-latest';
import { _get, _notNil } from '@/littledash';

export const stepHasErrors = (fields: Array<FieldConfig>, errors: FieldErrors): boolean => {
  return fields.some((field) => _notNil(_get(errors, field.name)));
};

export type StepVariant = 'error' | 'completed' | 'in_progress' | 'pending';

export const getStepVariant = (status: StepStatus, hasErrors: boolean): StepVariant => {
  if (hasErrors) {
    return 'error';
  }
  if (status === 'completed') {
    return 'completed';
  }
  if (status === 'in_progress') {
    return 'in_progress';
  }
  return 'pending';
};
